import { Routes, Route } from 'react-router-dom';
import SuperHomesLanding from './SuperHomesLanding.jsx';
import CartPage from './pages/CartPage.jsx';
import CheckoutPage from './pages/CheckoutPage.jsx';
import OrderConfirmationPage from './pages/OrderConfirmationPage.jsx';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<SuperHomesLanding />} />
      <Route path="/cart" element={<CartPage />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/order-confirmation" element={<OrderConfirmationPage />} />
    </Routes>
  );
}
